(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gnb"] && !Shopify.designMode) return;
  try {
    class GnbMenu extends HTMLElement {
    constructor() {
      super();
      this.hideTimer = null;
    }

    connectedCallback() {
      this.snbPanel = this.querySelector('.gnb__snb');
      this.links = this.querySelectorAll('.gnb__link[data-snb-target]');
      this.groups = this.querySelectorAll('.gnb__snb-list');
      this.defaultTarget = this.dataset.snbDefault || null;

      this.links.forEach((link) => {
        link.addEventListener('mouseenter', () => this.preview(link.dataset.snbTarget));
        link.addEventListener('focus', () => this.preview(link.dataset.snbTarget));
      });

      this.addEventListener('mouseleave', () => this.reset());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.reset();
      });

      this.cartIcon = this.querySelector('[data-gnb-cart-icon]');
      if (this.cartIcon && typeof subscribe === 'function') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) =>
          this.updateCartCount(event.cartData)
        );
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    updateCartCount(cartData) {
      if (!cartData) return;
      const bubble = this.cartIcon.querySelector('.cart-count-bubble');
      if (!bubble) return;

      // This badge mirrors sections/cart-icon-bubble.liquid, so when the mutation
      // carried that section, swap the rendered markup in — it keeps the
      // screen-reader count in sync too, not just the visible number.
      const sectionHTML = cartData.sections?.['cart-icon-bubble'];
      if (sectionHTML) {
        const rendered = new DOMParser()
          .parseFromString(sectionHTML, 'text/html')
          .querySelector('.cart-count-bubble');
        if (rendered) {
          bubble.replaceChildren(...rendered.childNodes);
          return;
        }
      }

      // /cart/add.js answers with the added line item, not the cart, so item_count
      // is absent there. `undefined < 100` is false, which used to render '99+' on
      // a one-item cart — only trust the count when it really is a number.
      const count = cartData.item_count;
      if (typeof count !== 'number') return;
      const countEl = bubble.querySelector('[aria-hidden="true"]');
      if (countEl) countEl.textContent = count < 100 ? count : '99+';
    }

    preview(target) {
      if (!target || !this.snbPanel) return;
      window.clearTimeout(this.hideTimer);
      this.links.forEach((link) => link.classList.toggle('is-previewing', link.dataset.snbTarget === target));
      this.groups.forEach((group) => {
        group.hidden = group.dataset.snbGroup !== target;
      });
    }

    reset() {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = window.setTimeout(() => {
        this.links.forEach((link) => link.classList.remove('is-previewing'));
        if (!this.snbPanel || !this.defaultTarget) return;
        this.groups.forEach((group) => {
          group.hidden = group.dataset.snbGroup !== this.defaultTarget;
        });
      }, 100);
    }
  }

  customElements.define('gnb-menu', GnbMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort-dropdown"] && !Shopify.designMode) return;
  try {
    class SortDropdown extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.label = this.querySelector('.dropdown-menu__label');
      this.select = this.querySelector('select');
      this.options = Array.from(this.querySelectorAll('.dropdown-menu__option'));

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectOption(option));
      });
    }

    selectOption(option) {
      const value = option.dataset.value;
      this.label.textContent = option.textContent.trim();
      this.options.forEach((candidate) => {
        const isSelected = candidate === option;
        candidate.classList.toggle('dropdown-menu__option--selected', isSelected);
        candidate.closest('li').setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
      if (this.select.value !== value) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (this.details) this.details.removeAttribute('open');
    }
  }

  customElements.define('sort-dropdown', SortDropdown);
  } catch(e) { console.error(e); }
})();

})();
